export default __webpack_public_path__ + "static/media/normal_line.2abe961c.svg";